<div class="payment-options">
	<h3 class="white" i18n="@@setting.payment_options"><span>Payment options</span></h3>
	<div class="payments-accepted" id="payments-accepted">
		<input class="styled-checkbox large card-payment-option" id="paymentsAccepted" type="checkbox" [checked]="merchantEnabled.cash" (click)="$event.preventDefault()">
		<label for="paymentsAccepted" i18n="@@payment_options.accept_cash_payment">Accept cash payments</label>
		<div class="switch-wrapper">
			<div class="switch">
				<input type="checkbox" [checked]="!merchantEnabled.cash" (change)="updatePaymentTab($event , 'cashPayment');false" id="auto-renew" name="auto-renew">
				<span class="slider round"></span>
			</div>
		</div>
	</div>

	<div class="payment-options__content">
		<div class="payment-card">
			<div class="payments-accepted" id="bankTransferPayment">
				<input class="styled-checkbox large card-payment-option" id="banktTransfers" type="checkbox" [checked]="merchantEnabled.banktransfer" (click)="showHidePaymentTab($event , 'bankTransferPayment');false">
				<label for="banktTransfers" i18n="@@payment_options.accept_bank_transfers">Accept Bank transfers</label>
				<div class="switch-wrapper" *ngIf="merchantTabsVisible.banktransfer">
					<div class="switch">
						<input type="checkbox" [checked]="!merchantEnabled.banktransfer" (change)="updatePaymentTab($event , 'bankTransferPayment');false" id="auto-renew2" name="auto-renew2">
						<span class="slider round"></span>
					</div>
				</div>

				<div class="payment-card__body show" *ngIf="merchantTabsVisible.banktransfer">
					<bank-info-tab [userDetails]="userDetails" (updateUserDetails)="updateUserDetails($event)"></bank-info-tab>
				</div>
			</div>

			<div class="payments-accepted" id="acceptCardPayment" *ngIf="isEnabledPayment()">
				<input class="styled-checkbox large card-payment-option" id="acceptCreditCard" type="checkbox" [checked]="merchantEnabled.creditCard" (click)="showHidePaymentTab($event , 'acceptCardPayment');false">
				<label for="acceptCreditCard" i18n="@@payment_options.accept_credit_card">Accept credit card payments</label>
				<div class="creditcards-items">
					<img src="/images/icons/cards/visa-logo.svg" alt="visa" loading="lazy">
					<img src="/images/icons/cards/master-card-logo.svg" alt="mastercard" loading="lazy">
					<img src="/images/icons/cards/apple-pay-logo.svg" alt="applepay" loading="lazy">
					<img src="/images/icons/cards/mada-high.png" class="mada" alt="mada" loading="lazy">
				</div>

				<div class="switch-wrapper" *ngIf="showInvoicePaymentTab()">
					<div class="switch">
						<!-- check any payment is on or off  -->
						<input type="checkbox" [checked]="!this.userDetails.accept_credit_card" (change)="updatePaymentTab($event , 'acceptCardPayment');false" id="auto-renew1" name="auto-renew1">
						<span class="slider round"></span>
					</div>
				</div>

				<div class="payment-card__body show" *ngIf="merchantTabsVisible.creditCard">
					<div class="content-container account-setting__merchant-id">
						<ul class="nav nav-pills merchant-nav" id="pills-tab" role="tablist">

							<!-- <li class="nav-item">
								<a class="nav-link" id="hyperpay-tab" data-toggle="pill" href="javascript:;" (click)="switchTab('hyperpay-tab')" [class.active]="activeTab == 'hyperpay-tab'" role="tab" aria-controls="pills-hyperpay-tab" aria-selected="false">
									<img src="/images/icons/cards/hyperpay-logo.png" alt="">
								</a>
							</li> -->

							<li class="nav-item">
								<a class="nav-link" id="tap-tab" data-toggle="pill" href="javascript:;" (click)="switchTab('tap-tab')" [class.active]="activeTab == 'tap-tab'" role="tab" aria-controls="pills-tap-tab" aria-selected="false">
									<img class="tap-logo" src="/images/icons/cards/tap-logo.png" alt>
								</a>
							</li>

							<!-- <li class="nav-item">
								<a class="nav-link" id="myfatoorah-tab" data-toggle="pill" href="javascript:;" (click)="switchTab('myfatoorah-tab')" [class.active]="activeTab == 'myfatoorah-tab'" role="tab" aria-controls="pills-myfatoorah-tab" aria-selected="false">
									<img class="myfatoorah-logo" src="/images/icons/cards/myfatoorah.png" alt="">
								</a>
							</li> -->

							<!-- <li class="nav-item">
								<a class="nav-link" id="moyasar-tab" data-toggle="pill" href="javascript:;" (click)="switchTab('moyasar-tab')" [class.active]="activeTab == 'moyasar-tab'" role="tab" aria-controls="pills-moyasar-tab" aria-selected="false">
									<img class="moyasar-logo" src="/images/icons/cards/moyasar-logo.png" alt>
								</a>
							</li> -->

							<li class="nav-item">
								<a class="nav-link" id="myfatoorah-tab" data-toggle="pill" href="javascript:;" (click)="switchTab('myfatoorah-tab')" [class.active]="activeTab == 'myfatoorah-tab'" role="tab" aria-controls="pills-myfatoorah-tab" aria-selected="false">
									<img class="myfatoorah-logo" src="/images/icons/cards/myfatoorah.png" alt="" loading="lazy">
								</a>
							</li>

							<!-- <li class="nav-item" *ngIf="userDetails?.paylink_info">
								<a class="nav-link" id="paylink-tab" data-toggle="pill" href="javascript:;" (click)="switchTab('paylink-tab')" [class.active]="activeTab == 'paylink-tab'" role="tab" aria-controls="pills-paylink-tab" aria-selected="false">
									<img class="paylink-logo" src="/images/icons/cards/paylink-logo.png" alt loading="lazy">
								</a>
							</li> -->

							<!-- *ngIf="allowedEmails.includes(userDetails.email)" -->
							<!-- <li class="nav-item">
								<a class="nav-link" id="tap-merchant-tab" data-toggle="pill" href="javascript:;" (click)="switchTab('tap-merchant-tab')" [class.active]="activeTab == 'tap-merchant-tab'" role="tab" aria-controls="pills-tap-merchant-tab" aria-selected="false">
									<img class="tap-logo" src="/images/icons/cards/tap-logo.png" alt>
								</a>
							</li> -->

						</ul>

            			<div class="tab-content merchant-content">

							<!-- <div class="tab-pane fade active show" id="hyperpay" role="tabpanel" aria-labelledby="hyperpay-tab" *ngIf="activeTab == 'hyperpay-tab'">
								<hyperpay-tab [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()" (updateUserDetails)="updateUserDetails($event)"></hyperpay-tab>
							</div> -->

							<div class="tab-pane fade active show" id="tap" role="tabpanel" aria-labelledby="tap-tab" *ngIf="activeTab == 'tap-tab'">
								<tap-tab [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()" (updateUserDetails)="updateUserDetails($event)"></tap-tab>
							</div>

							<!-- <div class="tab-pane fade active show" id="myfatoorah" role="tabpanel" aria-labelledby="myfatoorah-tab" *ngIf="activeTab == 'myfatoorah-tab'">
								<myfatoorah-tab [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()" (updateUserDetails)="updateUserDetails($event)"></myfatoorah-tab>
							</div> -->

							<!-- <div class="tab-pane fade active show" id="moyasar" role="tabpanel" aria-labelledby="moyasar-tab" *ngIf="activeTab == 'moyasar-tab'">
								<moyasar-tab [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()" (updateUserDetails)="updateUserDetails($event)"></moyasar-tab>
							</div> -->

							<div class="tab-pane fade active show" id="myfatoorah" role="tabpanel" aria-labelledby="myfatoorah-tab" *ngIf="activeTab == 'myfatoorah-tab'">
								<myfatoorah-tab [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()" (updateUserDetails)="updateUserDetails($event)"></myfatoorah-tab>
							</div>

							<!-- <div class="tab-pane fade active show" id="paylink" role="tabpanel" aria-labelledby="paylink-tab" *ngIf="activeTab == 'paylink-tab' && userDetails?.paylink_info">
								<paylink-tab [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()" (updateUserDetails)="updateUserDetails($event)"></paylink-tab>
							</div> -->

							<!-- <div class="tab-pane fade active show" id="tap" role="tabpanel" aria-labelledby="tap-merchant-tab" *ngIf="activeTab == 'tap-merchant-tab'">
								<tap-merchant-tab [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()" (updateUserDetails)="updateUserDetails($event)"></tap-merchant-tab>
							</div> -->

						</div>
					</div>
				</div>
			</div>

			<!-- <div class="payments-accepted" id="acceptTapPayment">
				<input class="styled-checkbox large card-payment-option" id="acceptTap" type="checkbox"
					[checked]="merchantEnabled.tap" (click)="showHidePaymentTab($event , 'acceptTapPayment');false">
				<label for="acceptTap" i18n="@@payment_options.accept_credit_card">Accept credit card payments</label>

				<div class="creditcards-items">
					<img src="/images/icons/cards/visa-logo.svg" alt="visa">
					<img src="/images/icons/cards/master-card-logo.svg" alt="mastercard">
					<img src="/images/icons/cards/mada-high.png" class="mada" alt="mada">
					<img src="/images/icons/cards/apple-pay-logo.svg" alt="applepay">
				</div>

				<div class="switch-wrapper" *ngIf="showInvoicePaymentTab()">
					<div class="switch">
						<input type="checkbox" [checked]="!this.userDetails.accept_credit_card"
							(change)="updatePaymentTab($event , 'acceptTapPayment');false" id="auto-renew1"
							name="auto-renew1">
						<span class="slider round"></span>
					</div>
				</div>

				<div class="payment-card__body show" *ngIf="merchantTabsVisible.tap">
					<div class="content-container account-setting__merchant-id">
						<ul class="nav nav-pills merchant-nav" id="pills-tab" role="tablist">
							<li class="nav-item">
								<a class="nav-link active" id="tap-tab" data-toggle="pill" href="javascript:;"
									(click)="switchTab('tap-tab')" role="tab" aria-controls="pills-tap-tab"
									aria-selected="false">
									<img src="/images/icons/cards/hyperpay-logo.png" alt="">
								</a>
							</li>
						</ul>
						<div class="tab-content merchant-content">
							<div class="tab-pane fade active show" id="tap" role="tabpanel" aria-labelledby="tap-tab">
								<tap-tab [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()"
									(updateUserDetails)="updateUserDetails($event)"></tap-tab>
							</div>
						</div>
					</div>
				</div>

			</div> -->

			<!-- Tamara Payment Tab-->
			<div class="payments-accepted" id="acceptTamara">
				<input class="styled-checkbox large card-payment-option" id="tamaraPayment" type="checkbox" [checked]="merchantEnabled.tamara" (click)="showHidePaymentTab($event , 'acceptTamara');false">
				<label for="tamaraPayment" i18n="@@payment_options.accept_tamara"> Accept payments via </label>
				<div class="tamara-logo mr-2 ml-2">
					<img src="/images/icons/tamara-logo.png" class="w-20" alt="tamara" loading="lazy">
				</div>

				<div class="switch-wrapper" *ngIf="userDetails.tamara_access_token && showTamaraPaymentTab()">
					<div class="switch">
						<input type="checkbox" [checked]="!this.userDetails.accept_tamara" (change)="updatePaymentTab($event , 'acceptTamara');false" id="auto-renew" name="auto-renew">
						<span class="slider round"></span>
					</div>
				</div>

				<div class="payment-card__body show" *ngIf="merchantTabsVisible.tamara">
					<tamara-tab class="w-100" [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()" (updateUserDetails)="updateUserDetails($event)"></tamara-tab>
				</div>
			</div>

			<div class="payments-accepted" id="acceptStc" *ngIf="isEnabledPayment()">
				<input class="styled-checkbox large card-payment-option" id="stcPayPayment" type="checkbox" [checked]="merchantEnabled.stcpay" (click)="showHidePaymentTab($event , 'stcPayPayment');false">
				<label for="stcPayPayment" i18n="@@payment_options.accept_stc_pay">Accept payments via</label>
				<div class="stcpay-logo">
					<img src="/images/icons/cards/stcbank-logo.svg" alt="stcpay" loading="lazy">
				</div>

				<a href="/images/stcpay-merchant.jfif" target="_blank" class="stcpay-logo" data-toggle="tooltip" data-placement="top" title="How to get Stcpay merchant ID?">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width="26px" height="26px">
						<path d="M 13 1.1875 C 6.476563 1.1875 1.1875 6.476563 1.1875 13 C 1.1875 19.523438 6.476563 24.8125 13 24.8125 C 19.523438 24.8125 24.8125 19.523438 24.8125 13 C 24.8125 6.476563 19.523438 1.1875 13 1.1875 Z M 15.460938 19.496094 C 14.851563 19.734375 14.367188 19.917969 14.003906 20.042969 C 13.640625 20.167969 13.222656 20.230469 12.742188 20.230469 C 12.007813 20.230469 11.433594 20.050781 11.023438 19.691406 C 10.617188 19.335938 10.414063 18.878906 10.414063 18.324219 C 10.414063 18.109375 10.429688 17.890625 10.460938 17.667969 C 10.488281 17.441406 10.539063 17.191406 10.605469 16.90625 L 11.367188 14.21875 C 11.433594 13.960938 11.492188 13.71875 11.539063 13.488281 C 11.585938 13.257813 11.605469 13.046875 11.605469 12.855469 C 11.605469 12.515625 11.535156 12.273438 11.394531 12.140625 C 11.25 12.003906 10.980469 11.9375 10.582031 11.9375 C 10.386719 11.9375 10.183594 11.96875 9.976563 12.027344 C 9.769531 12.089844 9.59375 12.148438 9.445313 12.203125 L 9.648438 11.375 C 10.144531 11.171875 10.621094 11 11.078125 10.855469 C 11.53125 10.710938 11.964844 10.636719 12.367188 10.636719 C 13.097656 10.636719 13.664063 10.816406 14.058594 11.167969 C 14.453125 11.519531 14.652344 11.980469 14.652344 12.542969 C 14.652344 12.660156 14.640625 12.867188 14.613281 13.160156 C 14.585938 13.453125 14.535156 13.722656 14.460938 13.972656 L 13.703125 16.652344 C 13.640625 16.867188 13.585938 17.113281 13.535156 17.386719 C 13.488281 17.660156 13.464844 17.871094 13.464844 18.011719 C 13.464844 18.367188 13.542969 18.613281 13.703125 18.742188 C 13.859375 18.871094 14.136719 18.933594 14.53125 18.933594 C 14.714844 18.933594 14.921875 18.902344 15.15625 18.839844 C 15.386719 18.773438 15.554688 18.71875 15.660156 18.667969 Z M 15.324219 8.617188 C 14.972656 8.945313 14.546875 9.109375 14.050781 9.109375 C 13.554688 9.109375 13.125 8.945313 12.769531 8.617188 C 12.414063 8.289063 12.238281 7.890625 12.238281 7.425781 C 12.238281 6.960938 12.417969 6.558594 12.769531 6.226563 C 13.125 5.894531 13.554688 5.730469 14.050781 5.730469 C 14.546875 5.730469 14.972656 5.894531 15.324219 6.226563 C 15.679688 6.558594 15.855469 6.960938 15.855469 7.425781 C 15.855469 7.890625 15.679688 8.289063 15.324219 8.617188 Z" />
					</svg>
				</a>

				<div class="switch-wrapper" *ngIf="userDetails.stcpay_merchant_id && showStcpayPaymentTab()">
					<div class="switch">
						<input type="checkbox" [checked]="!this.userDetails.accept_stcpay_payment" (change)="updatePaymentTab($event , 'stcPayPayment');false" id="auto-renew" name="auto-renew">
						<span class="slider round"></span>
					</div>
				</div>

				<div class="payment-card__body show" *ngIf="merchantTabsVisible.stcpay">
					<stcpay-tab class="w-100" [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()" (updateUserDetails)="updateUserDetails($event)"></stcpay-tab>
				</div>
			</div>

			<div class="payments-accepted" id="acceptStc">
				<input class="styled-checkbox large card-payment-option" id="paypalPayment" type="checkbox" [checked]="merchantEnabled.paypal" (click)="showHidePaymentTab($event , 'paypalPayment');false">
				<label for="paypalPayment" i18n="@@payment_options.accept_stc_pay">Accept payments via</label>
				<div class="stcpay-logo">
					<img src="/images/icons/cards/paypal-icon.svg" alt="paypal" loading="lazy">
				</div>

				<div class="switch-wrapper" *ngIf="userDetails?.payment_model?.paypal_is_active && showPaypalPaymentTab()">
					<div class="switch">
						<input type="checkbox" [checked]="!userDetails.accept_paypal_payment" (change)="updatePaymentTab($event , 'paypalPayment');false" id="auto-renew" name="auto-renew">
						<span class="slider round"></span>
					</div>
				</div>

				<div class="payment-card__body show" *ngIf="merchantTabsVisible.paypal">
					<paypal-tab class="w-100" [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()" (updateUserDetails)="updateUserDetails($event)"></paypal-tab>
				</div>
			</div>

			<div class="payments-accepted" id="acceptStc">
				<input class="styled-checkbox large card-payment-option" id="stripePayment" type="checkbox"
					[checked]="merchantEnabled.stripe" (click)="showHidePaymentTab($event , 'stripePayment');false">
				<label for="stripePayment" i18n="@@payment_options.accept_stc_pay">Accept payments via</label>
				<div class="stcpay-logo">
					<img src="/images/icons/cards/stripe-icon.svg" alt="stripe" loading="lazy">
				</div>

				<div class="switch-wrapper" *ngIf="userDetails?.payment_model?.stripe_is_active && showStripePaymentTab()">
					<div class="switch">
						<input type="checkbox" [checked]="!userDetails.accept_stripe_payment" (change)="updatePaymentTab($event , 'stripePayment');false" id="auto-renew" name="auto-renew">
						<span class="slider round"></span>
					</div>
				</div>

				<div class="payment-card__body show" *ngIf="merchantTabsVisible.stripe">
					<stripe-tab class="w-100" [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()" (updateUserDetails)="updateUserDetails($event)"></stripe-tab>
				</div>
			</div>

			<div class="payments-accepted" id="acceptStc" *ngIf="isEnabledPaymentModel('opay')">
				<input class="styled-checkbox large card-payment-option" id="opayPayment" type="checkbox" [checked]="merchantEnabled.opay" (click)="showHidePaymentTab($event , 'opayPayment');false">
				<label for="opayPayment" i18n="@@payment_options.accept_stc_pay">Accept payments via</label>
				<div class="stcpay-logo">
					<img src="/images/icons/cards/opay-icon.png" alt="opay" class="w-100" loading="lazy">
				</div>

				<div class="switch-wrapper" *ngIf="userDetails?.payment_model?.opay_is_active && showOpayPaymentTab()">
					<div class="switch">
						<input type="checkbox" [checked]="!userDetails.accept_opay_payment" (change)="updatePaymentTab($event , 'opayPayment');false" id="auto-renew" name="auto-renew">
						<span class="slider round"></span>
					</div>
				</div>

				<div class="payment-card__body show" *ngIf="merchantTabsVisible.opay">
					<opay-tab class="w-100" [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()" (updateUserDetails)="updateUserDetails($event)"></opay-tab>
				</div>
			</div>

			<!-- <div class="payments-accepted" id="acceptStc" *ngIf="hasStore()">
				<input class="styled-checkbox large card-payment-option" id="otoDelivery" type="checkbox"
					[checked]="deliveryEnabled.otoDelivery" (click)="showHideDeliveryTab($event , 'otoDelivery');false">
				<label for="otoDelivery" i18n="@@payment_options.accept_stc_pay">Accept Delivery via</label>
				<div class="stcpay-logo">
					<img src="/images/icons/cards/OTO-logo.jpg" class="w-75" alt="stripe">
				</div>

				<div class="switch-wrapper" *ngIf="userDetails?.oto_info?.is_active && showDeliveryTab()">
					<div class="switch">
						<input type="checkbox" [checked]="!userDetails?.accept_oto"
							(change)="updateDeliveryTab($event , 'otoDelivery');false" id="auto-renew"
							name="auto-renew">
						<span class="slider round"></span>
					</div>
				</div>

				<div class="payment-card__body show" *ngIf="deliveryTabsVisible.otoDelivery">
					<oto-tab class="w-100" [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()"
						(updateUserDetails)="updateUserDetails($event)">
					</oto-tab>
				</div>
			</div> -->

			<!-- <div class="payments-accepted" id="acceptCardPayment" *ngIf="hasStore()">
				<input class="styled-checkbox large card-payment-option" id="delivery" type="checkbox"
					[checked]="deliveryEnabled.delivery" (click)="showHideDeliveryTab($event , 'delivery');false">
				<label for="delivery" i18n="@@payment_options.accept_delivery_via">Accept Delivery via</label>

				<div class="switch-wrapper" *ngIf="showDeliveryTab()">
					<div class="switch">
						<input type="checkbox" [checked]="!userDetails?.accept_delivery_order"
							(change)="updateDeliveryTab($event , 'delivery');false" id="auto-renew" name="auto-renew">
						<span class="slider round"></span>
					</div>
				</div>

				<div class="payment-card__body show" *ngIf="deliveryTabsVisible.delivery">
					<div class="content-container account-setting__merchant-id">
						<ul class="nav nav-pills merchant-nav" id="pills-tab" role="tablist">
							<li class="nav-item">
								<a class="nav-link" id="oto-tab" data-toggle="pill" href="javascript:;"
									(click)="switchDeliveryTab('oto-tab')"
									[class.active]="activeDeliveryTab == 'oto-tab'" role="tab"
									aria-controls="pills-oto-tab" aria-selected="false">
									<img class="oto-logo" src="/images/icons/cards/OTO-logo.jpg" alt="OTO">
								</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" id="careem-tab" data-toggle="pill" href="javascript:;"
									(click)="switchDeliveryTab('careem-tab')"
									[class.active]="activeDeliveryTab == 'careem-tab'" role="tab"
									aria-controls="pills-careem-tab" aria-selected="false">
									<img class="careem-logo" src="/images/icons/cards/careem-logo.png" alt="">
								</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" id="mrsool-tab" data-toggle="pill" href="javascript:;"
									(click)="switchDeliveryTab('mrsool-tab')"
									[class.active]="activeDeliveryTab == 'mrsool-tab'" role="tab"
									aria-controls="pills-mrsool-tab" aria-selected="false">
									<img class="mrsool-logo" src="/images/icons/cards/mrsool-logo.svg" alt="">
								</a>
							</li>
						</ul>

						<div class="tab-content merchant-content">
							<div class="tab-pane fade active show" id="oto" role="tabpanel" aria-labelledby="oto-tab"
								*ngIf="activeDeliveryTab == 'oto-tab'">
								<oto-tab class="w-100" [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()"
									(updateUserDetails)="updateUserDetails($event)">
								</oto-tab>
							</div>
							<div class="tab-pane fade active show" id="careem" role="tabpanel"
								aria-labelledby="careem-tab" *ngIf="activeDeliveryTab == 'careem-tab'">
								<careem-tab class="w-100" [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()"
									(updateUserDetails)="updateUserDetails($event)">
								</careem-tab>
							</div>
							<div class="tab-pane fade active show" id="mrsool" role="tabpanel"
								aria-labelledby="mrsool-tab" *ngIf="activeDeliveryTab == 'mrsool-tab'">
								<mrsool-tab class="w-100" [userDetails]="userDetails" (goToPlan)="scrollToPlanTab()"
									(updateUserDetails)="updateUserDetails($event)">
								</mrsool-tab>
							</div>
						</div>
					</div>
				</div>
			</div> -->

			<!-- <div class="payments-accepted" id="acceptStc">
				<input class="styled-checkbox large card-payment-option" id="foodicsMarketplace" type="checkbox"
					[checked]="merchantEnabled.foodics"
					(click)="showHidePaymentTab($event , 'foodicsMarketplace');false">
				<label for="foodicsMarketplace" i18n="@@payment_options.foodics_marketplace">Foodics marketplace</label>
				<div class="foodics-logo">
					<img src="/images/icons/cards/foodics-icon.png" alt="foodics" class="w-100">
				</div>

				<div class="switch-wrapper"
					*ngIf="userDetails?.marketplace_model?.foodics_is_active && showFoodicsPaymentTab()">
					<div class="switch">
						<input type="checkbox" [checked]="!userDetails.accept_foodics"
							(change)="updatePaymentTab($event , 'foodicsMarketplace'); false" id="auto-renew"
							name="auto-renew">
						<span class="slider round"></span>
					</div>
				</div>

				<div class="payment-card__body show" *ngIf="merchantTabsVisible.foodics">
					<div class="account-setting__actionButtonsWrap">
						<button class="tu-btn blue" (click)="generateAuthUrl()"
							i18n="@@payment_options.connect_with_foodics"
							*ngIf="!userDetails?.marketplace_model?.foodics_token; else tokenPresent">Connect with
							Foodics</button>
						<ng-template #tokenPresent>
							<button class="tu-btn blue transparent disabled"
								i18n="@@payment_options.connected_with_foodics">Connected with Foodics</button>
						</ng-template>

					</div>
				</div>
			</div> -->

		</div>
	</div>

</div>
